'use strict';


module.exports = require('./lib/');



//////////////////
// WEBPACK FOOTER
// ./~/markdown-it/index.js
// module id = 939
// module chunks = 1